__turbopack_context__.v({
  "heroList": "PrintModal-module__psWXNa__heroList",
  "image": "PrintModal-module__psWXNa__image",
  "item": "PrintModal-module__psWXNa__item",
  "removeIcon": "PrintModal-module__psWXNa__removeIcon",
});
